import { useAuth } from '@/contexts/AuthContext'

export const useUserStatus = () => {
  const { userData } = useAuth()

  const isActive = userData?.active !== false
  const isInactive = userData?.active === false

  return {
    isActive,
    isInactive,
    userData,
  }
}
